import { render, staticRenderFns } from "./SuggestBundle.vue?vue&type=template&id=3be8ca0e&scoped=true&"
import script from "./SuggestBundle.vue?vue&type=script&lang=js&"
export * from "./SuggestBundle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be8ca0e",
  null
  
)

export default component.exports